module.exports = __webpack_public_path__ + "pr.0a04f734b0ffa110adce.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pr.svg
// module chunks = styles